import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import clsx from 'clsx';
import React, { useState, useCallback } from 'react';
import { strToInteger } from '@/utils/numbers';
import { preventNonNumericInput } from '@/utils/dom';
import { getDefaultPadding, getEmptyPadding, MAX_PADDING, MIN_PADDING } from './util';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var PlusIcon = function PlusIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("line", {
      x1: "12",
      y1: "5",
      x2: "12",
      y2: "19"
    }), /*#__PURE__*/_jsx("line", {
      x1: "5",
      y1: "12",
      x2: "19",
      y2: "12"
    })]
  }));
};

PlusIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "14",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  className: "align-middle"
};

var MinusIcon = function MinusIcon(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/_jsx("line", {
      x1: "5",
      y1: "12",
      x2: "19",
      y2: "12"
    })
  }));
};

MinusIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "14",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round"
};

var ClearIcon = function ClearIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M20.6234 3.37658C21.1255 3.87868 21.1255 4.69275 20.6234 5.19485L5.19485 20.6234C4.69275 21.1255 3.87868 21.1255 3.37658 20.6234C2.87447 20.1213 2.87447 19.3073 3.37658 18.8051L18.8051 3.37658C19.3073 2.87447 20.1213 2.87447 20.6234 3.37658Z",
      fill: "currentColor"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3.37658 3.37658C3.87868 2.87447 4.69275 2.87447 5.19485 3.37658L20.6234 18.8051C21.1255 19.3073 21.1255 20.1213 20.6234 20.6234C20.1213 21.1255 19.3073 21.1255 18.8051 20.6234L3.37658 5.19485C2.87447 4.69275 2.87447 3.87868 3.37658 3.37658Z",
      fill: "currentColor"
    })]
  }));
};

ClearIcon.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

const PaddingControl = _ref => {
  let {
    className,
    defaultValue,
    placeholders,
    onChange
  } = _ref;
  const {
    0: padding,
    1: setPadding
  } = useState(getDefaultPadding(defaultValue));
  const handleOnChange = useCallback((key, value) => {
    const changed = _objectSpread(_objectSpread({}, padding), {}, {
      [key]: value === null || isNaN(value) ? null : Math.min(MAX_PADDING, Math.max(MIN_PADDING, value))
    });

    typeof onChange === 'function' && onChange(changed);
    setPadding(changed);
  }, [padding, onChange, setPadding]);
  const clearPadding = useCallback(() => {
    const emptyPadding = getEmptyPadding();
    setPadding(emptyPadding);
    typeof onChange === 'function' && onChange(emptyPadding);
  }, [setPadding, onChange]);
  return /*#__PURE__*/_jsxs("div", {
    className: clsx(styles.container, className),
    children: [/*#__PURE__*/_jsx(NumberInput, _objectSpread(_objectSpread({}, getInputProps('paddingTop', {
      padding,
      placeholders
    })), {}, {
      onChange: value => handleOnChange('paddingTop', value),
      placement: "top"
    })), /*#__PURE__*/_jsx(NumberInput, _objectSpread(_objectSpread({}, getInputProps('paddingRight', {
      padding,
      placeholders
    })), {}, {
      onChange: value => handleOnChange('paddingRight', value),
      placement: "right"
    })), /*#__PURE__*/_jsx(ClearField, {
      onClear: () => clearPadding()
    }), /*#__PURE__*/_jsx(NumberInput, _objectSpread(_objectSpread({}, getInputProps('paddingBottom', {
      padding,
      placeholders
    })), {}, {
      onChange: value => handleOnChange('paddingBottom', value),
      placement: "bottom"
    })), /*#__PURE__*/_jsx(NumberInput, _objectSpread(_objectSpread({}, getInputProps('paddingLeft', {
      padding,
      placeholders
    })), {}, {
      onChange: value => handleOnChange('paddingLeft', value),
      placement: "left"
    }))]
  });
};

const NumberInput = _ref2 => {
  let {
    placement,
    value,
    placeholder,
    onChange
  } = _ref2;
  return /*#__PURE__*/_jsxs("div", {
    className: clsx(styles.field, styles[`field--${placement}`]),
    children: [/*#__PURE__*/_jsx("button", {
      className: styles.button,
      type: "button",
      onClick: () => {
        onChange(value === null ? 0 : value - 1);
      },
      children: /*#__PURE__*/_jsx(MinusIcon, {})
    }), /*#__PURE__*/_jsx("input", {
      type: "number",
      min: MIN_PADDING,
      max: MAX_PADDING,
      value: value === null ? '' : value,
      placeholder: placeholder,
      className: clsx(styles.input),
      onKeyDown: preventNonNumericInput,
      onChange: e => {
        const isEmpty = e.target.value === '';
        const changed = strToInteger(e.target.value);
        onChange(isEmpty ? null : changed);
      }
    }), /*#__PURE__*/_jsx("button", {
      className: styles.button,
      type: "button",
      onClick: () => {
        onChange(value === null ? 1 : value + 1);
      },
      children: /*#__PURE__*/_jsx(PlusIcon, {})
    })]
  });
};

const ClearField = _ref3 => {
  let {
    onClear
  } = _ref3;
  return /*#__PURE__*/_jsx("div", {
    className: clsx(styles.clearField, styles.field, styles['field--middle']),
    children: /*#__PURE__*/_jsx("button", {
      type: "button",
      onClick: () => onClear(),
      children: /*#__PURE__*/_jsx(ClearIcon, {})
    })
  });
};

function getInputProps(key, ctx) {
  var _ctx$placeholders;

  return {
    name: key,
    value: ctx.padding[key],
    placeholder: ((_ctx$placeholders = ctx.placeholders) === null || _ctx$placeholders === void 0 ? void 0 : _ctx$placeholders[key]) || ''
  };
}

export default PaddingControl;